var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 200,
    viewBox: "0 0 768 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 50C26.8629 50 0 76.8629 0 110C0 143.137 26.8629 170 60 170C76.0599 170 90.646 163.69 101.415 153.415L81.6054 133.605C75.9126 138.819 68.3278 142 60 142C47.3475 142 36.4101 134.657 31.2169 124H72H88.7831H118.358C119.432 119.508 120 114.821 120 110C120 76.8629 93.1371 50 60 50ZM60 78C47.3475 78 36.4101 85.3431 31.2169 96H88.7831C83.5899 85.3431 72.6525 78 60 78Z",
    fill: "#12D3A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 80C130 63.4315 143.431 50 160 50H174H188H218L210 78H209.934H167C162.029 78 158 82.0294 158 87C158 91.9706 162.029 96 167 96H188C204.569 96 218 109.431 218 126V140C218 156.569 204.569 170 188 170H174H160H130L138 142H138.066H181C185.971 142 190 137.971 190 133C190 128.029 185.971 124 181 124H160C143.431 124 130 110.569 130 94V80Z",
    fill: "#12D3A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242 8L258 0V12.9333V13V50H294L286 78H258V102C258 122.741 273.787 139.796 294 141.803V170H290C256.863 170 230 143.137 230 110V78V50V13V12.9333L242 12.9333V8Z",
    fill: "#12D3A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396 37L412 45V50H424V110V170H396V160.764C386.738 166.614 375.765 170 364 170C330.863 170 304 143.137 304 110C304 76.8629 330.863 50 364 50C375.765 50 386.738 53.3859 396 59.2365V50V37ZM396 110C396 92.3269 381.673 78 364 78C346.327 78 332 92.3269 332 110C332 127.673 346.327 142 364 142C381.673 142 396 127.673 396 110Z",
    fill: "#12D3A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464 0L448 8V12.9333L436 12.9334V110C436 143.137 462.863 170 496 170C529.137 170 556 143.137 556 110C556 76.8629 529.137 50 496 50C484.235 50 473.262 53.386 464 59.2365V12.9333V0ZM496 142C478.327 142 464 127.673 464 110C464 92.3269 478.327 78 496 78C513.673 78 528 92.3269 528 110C528 127.673 513.673 142 496 142Z",
    fill: "#12D3A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M768 0L752 8V13L740 13V59.2365C730.738 53.3859 719.765 50 708 50C674.863 50 648 76.8629 648 110C648 143.137 674.863 170 708 170C741.137 170 768 143.137 768 110V104V13V0ZM708 78C725.673 78 740 92.3269 740 110C740 127.673 725.673 142 708 142C690.327 142 676 127.673 676 110C676 92.3269 690.327 78 708 78Z",
    fill: "#12D3A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568 37L584 45V50H596V170H584H568V50V37Z",
    fill: "#12D3A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636 0L620 8V13L608 13V170H620H636V13V0Z",
    fill: "#12D3A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d1d346a9977decd13c305e59a4002eca.svg";
export { ForwardRef as ReactComponent };